import { OrderState } from '@/lib/types/orderState';

export const defaultOrderState: OrderState = {
  itemCount: 0,
  token: null,
  tokenType: 'guest',
};
